<script>
import sweetAlert from "@/mixins/sweetAlert";

export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
  },
  mixins: [sweetAlert],
  methods: {
    async downloadURI(uri, name) {
      try{
        this.successToast(name+"のダウンロードを開始します。", false, 3000);
        // await fetch(uri ,{mode: "no-cors"})
        await fetch(uri)
          .then(response => response.blob())
          .then(blob => {
            // console.log(blob)
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
            link.remove();
          });
          this.successToast(name+"をダウンロードしました。", false, 3000);
        }
      catch(e){
        this.errorToast(name+"のダウンロードに失敗しました。", false, 3000);
      }
    }
  },
}
</script>

<template>
  <div>
    <div
      v-for="(file, index) in files"
      :key="`file_${index}`"
      class="file d-flex align-items-center gap-2 cursor-pointer"
      @click="downloadURI(file.file_url, file.file_name)"
    >
      <div class="file-name">{{file.file_name}}</div>
      <i class="bx bxs-download"></i>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.file {
  color: #0576b9;
  .file-name {
    text-decoration: underline;
  }
}
</style>
